export class FriendlyDateFactory {
  readonly #today: string;
  readonly #yesterday: string;

  constructor() {
    const referenceDate = new Date();
    this.#today = referenceDate.toLocaleDateString();
    referenceDate.setDate(-1);
    this.#yesterday = referenceDate.toLocaleDateString();
  }

  getDateString(date: Date | number | string): string {
    if (!(date instanceof Date)) {
      date = new Date(date);
    }
    const dateStr = date.toLocaleDateString();
    switch (dateStr) {
      case this.#today:
        return 'Today';
      case this.#yesterday:
        return 'Yesterday';
      default:
        return dateStr;
    }
  }
}
